// import { Link } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import React, { Component } from "react";
import { getVehicle } from "../graphql/queries";
import gql from "graphql-tag";
import { spinnerService } from "@chevtek/react-spinners";
import moment from "moment";
import { Label, Button as Btn, Container, Row, Col } from "reactstrap";
import Card from "../components/Card/Card.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { styles } from "../assets/css/styles";
import { userLogout } from "../redux/actions/index.js";
import Select from "@material-ui/core/Select";
import { getUserType } from "../common/util.js";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import PersonIcon from "@material-ui/icons/Person";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { TextField } from "@material-ui/core";
class InspectionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicle: {},
      type: null,
      open: false,
      regType: "",
      inspType: "",
      openConfirm: false,
      bitChecked: false,
      dotChecked: false,
      deactivated: "",
      mileage: "",
      mileageBox: false
    };
  }
  notify = msg => toast(msg);
  startInsp = () => {
    const { regType, mileage, vehicle } = this.state;
    if (["", null, undefined].includes(mileage)) {
      this.setState({
        mileageBox: true
      });
      return;
    } else if (this.props.location.state && this.props.location.state.mech) {
      this.props.history.push(
        `/mech/customer/${this.props.match.params.cId}/inspection/new/start/inspection/${vehicle.id}/insp`,
        {
          inspType:
            regType === "FEDERAL" ? "DOT" : regType === "BIT" ? "BIT" : "",
          mileage,
          mech: this.props.location.state.mech
        }
      );
    } else {
      this.props.history.push(
        `/inspection/new/start/inspection/${vehicle.id}/insp`,
        {
          inspType:
            regType === "FEDERAL" ? "DOT" : regType === "BIT" ? "BIT" : "",
          mileage,
          mech: this.props.location.state.mech
        }
      );
    }
  };
  startSpecifiedInsp = () => {
    const { dotChecked, bitChecked, vehicle, mileage } = this.state;
    //
    if (!dotChecked && !bitChecked) {
      this.setState({ open: true });
    }
    if (["", null, undefined].includes(mileage)) {
      this.setState({
        mileageBox: true
      });
      return;
    }

    if (dotChecked && !bitChecked) {
      this.setState({ inspType: "DOT" }, () => {
        if (this.props.location.state && this.props.location.state.mech) {
          this.props.history.push(
            `/mech/customer/${this.props.match.params.cId}/inspection/new/start/inspection/${vehicle.id}/insp`,
            {
              inspType: "DOT",
              mileage,
              mech: this.props.location.state.mech
            }
          );
        } else
          this.props.history.push(
            `/inspection/new/start/inspection/${vehicle.id}/insp`,
            {
              inspType: "DOT",
              mileage
            }
          );
      });
    }
    if (bitChecked && !dotChecked) {
      this.setState({ inspType: "BIT" }, () => {
        if (this.props.location.state && this.props.location.state.mech) {
          this.props.history.push(
            `/mech/customer/${this.props.match.params.cId}/inspection/new/start/inspection/${vehicle.id}/insp`,
            {
              inspType: "BIT",
              mileage,
              mech: this.props.location.state.mech
            }
          );
        } else
          this.props.history.push(
            `/inspection/new/start/inspection/${vehicle.id}/insp`,
            {
              inspType: "BIT",
              mileage
            }
          );
      });
    }
    if (bitChecked && dotChecked) {
      let date1 = vehicle.nextInspectionDue[0].nextDueDate;
      let date2 = vehicle.nextInspectionDue[1].nextDueDate;
      let isFed = moment(new Date(date1)).isBetween(
        new Date(),
        new Date(date2)
      );
      this.setState({ inspType: isFed ? "DOTANDBIT" : "BIT" }, () => {
        if (this.props.location.state && this.props.location.state.mech) {
          this.props.history.push(
            `/mech/customer/${this.props.match.params.cId}/inspection/new/start/inspection/${vehicle.id}/insp`,
            {
              inspType: isFed ? "DOTANDBIT" : "BIT",
              mileage,
              mech: this.props.location.state.mech
            }
          );
        } else
          this.props.history.push(
            `/inspection/new/start/inspection/${vehicle.id}/insp`,
            {
              inspType: isFed ? "DOTANDBIT" : "BIT",
              mileage
            }
          );
      });
    }
  };

  handleClose = () => {
    this.setState({ open: false }, () => {});
  };

  cancelForm = () => {
     this.props.history.goBack();
  };

  loadInspection = async id => {
    spinnerService.show("mySpinner");
    const { client } = this.props;
    const data = await client.query({
      query: gql(getVehicle),
      fetchPolicy: `network-only`,
      variables: { id }
    });
    let temp = data.data.getVehicle;
    // const insp = data.data.getVehicle.nextInspectionDue;
    // const date1 = insp && insp.length > 0 ? insp[0].nextDueDate : null;
    // const date2 = insp && insp.length > 1 ? insp[1].nextDueDate : null;
    this.setState(
      {
        vehicle: data.data.getVehicle,
        regType: data.data.getVehicle.customer.registeredInspectionType,
        deactivated:
          !temp.deactivateBIT && !temp.deactivateDOT
            ? ""
            : !temp.deactivateBIT && temp.deactivateDOT
            ? "DOT"
            : temp.deactivateBIT && !temp.deactivateDOT
            ? "BIT"
            : ""
      },
      () => {
        if (this.state.regType === "FEDERAL_BIT") {
          if (["", "None"].includes(this.state.deactivated)) {
            this.setState({
              bitChecked: true,
              dotChecked: true,
              mileageBox: true
            });
          } else if (this.state.deactivated === "DOT") {
            this.setState({
              bitChecked: true,
              dotChecked: false,
              mileageBox: true
            });
          } else if (this.state.deactivated === "BIT") {
            this.setState({
              bitChecked: false,
              dotChecked: true,
              mileageBox: true
            });
          }
        } else {
          this.setState({ mileageBox: true });
        }
      }
    );
    spinnerService.hide("mySpinner");
  };
  getInspectionType() {
    return <div>Test UI</div>;
  }
  async componentDidMount() {
    if (this.props.data === undefined || this.props.data.length == 0) {
      await this.loadInspection(this.props.match.params.id);
    } else {
      // this.fetchFromStore(this.props.match.params.id);
      await this.loadInspection(this.props.match.params.id);
      await true;
    }
  }
  RenderMileageBox = () => (
    <div>
      <Dialog
        open={this.state.mileageBox}
        onClose={() =>
          this.setState({
            mileageBox: false
          })
        }
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth="true"
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">Starting Mileage</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              width: "fit-content"
            }}
          >
            <TextField
              id="outlined-number"
              label="Number"
              value={this.state.mileage}
              onChange={e =>
                this.setState({
                  mileage: e.target.value
                })
              }
              type="number"
              InputLabelProps={{
                shrink: true
              }}
              margin="normal"
              variant="outlined"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div>
            <Button
              onClick={() =>
                this.setState({
                  mileageBox: false
                })
              }
              color="primary"
              disabled={["", null, undefined].includes(this.state.mileage)}
            >
              Continue
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );

  RenderInspDialog = () => (
    <div>
      <Dialog
        open={this.state.open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth="true"
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">
          Which inspection to start?
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              width: "fit-content"
            }}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.bitChecked}
                    onClick={e =>
                      this.setState({
                        bitChecked: e.target.checked
                      })
                    }
                    value="bitChecked"
                    color="primary"
                  />
                }
                label="BIT 90 DAYS Inspection"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.dotChecked}
                    onClick={e =>
                      this.setState({
                        dotChecked: e.target.checked
                      })
                    }
                    value="dotChecked"
                    color="primary"
                  />
                }
                label="DOT ANNUAL Inspection"
              />
            </FormGroup>
          </div>
        </DialogContent>
        <DialogActions>
          <div>
            <Button
              onClick={this.handleClose}
              color="primary"
              disabled={!this.state.bitChecked && !this.state.dotChecked}
            >
              Select
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );

  render() {
    let { vehicle } = this.state;
    const { dotChecked, bitChecked, regType } = this.state;
    let { user } = this.props;
    let date = new Date();
    let inspectionType = null;
    if (regType !== "FEDERAL_BIT") {
      if (vehicle.nextInspectionDue !== undefined) {
        if (vehicle.nextInspectionDue && vehicle.nextInspectionDue.length > 1) {
          inspectionType = this.getInspectionType();
        } else {
          inspectionType =
            vehicle.nextInspectionDue &&
            vehicle.nextInspectionDue[0].inspectionType;
        }
      }
    } else {
      if (vehicle.nextInspectionDue !== undefined) {
        if (vehicle.nextInspectionDue && vehicle.nextInspectionDue.length > 2) {
          inspectionType = this.getInspectionType();
        } else {
          if (dotChecked && !bitChecked) {
            inspectionType =
              vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[0].inspectionType ===
                "DOT_ANNUAL_INSPECTION"
                ? "DOT Annual Inspection"
                : vehicle.nextInspectionDue[0].inspectionType;
          } else if (!dotChecked && bitChecked) {
            if (
              vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue.length !== 1
            ) {
              inspectionType =
                vehicle.nextInspectionDue[1].inspectionType ===
                "BIT_90DAY_INSPECTION"
                  ? "BIT 90 Day Inspection"
                  : vehicle.nextInspectionDue[1].inspectionType;
            } else if (
              vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue.length === 1
            ) {
              inspectionType =
                vehicle.nextInspectionDue[0].inspectionType ===
                "BIT_90DAY_INSPECTION"
                  ? "BIT 90 Day Inspection"
                  : vehicle.nextInspectionDue[0].inspectionType;
            }
            // inspectionType = vehicle.nextInspectionDue[1].inspectionType;
          } else if (dotChecked && bitChecked) {
            inspectionType = "DOT & BIT Inspection";
          }
        }
      }
    }
    return (
      <div style={{ marginTop: -15 }}>
        <main ref="main" App>
          <section className="section section-shaped section-lg">
            <Container className="pt-lg-sm pt-2">
              <Row className="justify-content-left">
                <Col lg={12} style={{}}>
                  <Card style={{ height: "350px" }}>
                    <CardHeader
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      <Row>
                        <Col sm={4}>
                          <div style={{ float: "left" }}>
                            <h4
                              style={{ fontWeight: "bold" }}
                              // className={styles.cardTitleWhite}
                            >
                              Start Inspection
                            </h4>
                            <div>
                              {moment(new Date()).format("dddd DD MMMM YYYY")}
                            </div>
                          </div>
                        </Col>

                        <Col sm={4}>
                          <h2 style={{ marginTop: "-10px" }}>
                            {user.username}
                          </h2>
                          <h6 style={{ marginTop: "-15px" }}>
                            DOT/BIT Inspector
                          </h6>
                        </Col>
                        <Col sm={4}>
                          <div style={{ float: "right", paddingLeft: "6%" }}>
                            {" "}
                            <div style={{ fontWeight: "bold" }}>
                              {inspectionType}
                              {(dotChecked || bitChecked) &&
                                ["", "None"].includes(
                                  this.state.deactivated
                                ) && (
                                  <IconButton
                                    style={{
                                      color: "rgba(255, 255, 255, 0.54)"
                                    }}
                                    aria-label="edit"
                                    size="small"
                                    onClick={() => {
                                      this.setState({
                                        open: true
                                      });
                                    }}
                                    variant="outlined"
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                )}
                            </div>
                            {regType !== "FEDERAL_BIT" ? (
                              <React.Fragment>
                                <div style={{ fontWeight: "bold" }}>
                                  {vehicle.nextInspectionDue === null ||
                                  vehicle.nextInspectionDue === undefined ||
                                  vehicle.nextInspectionDue.length === 0
                                    ? ""
                                    : "DOT Next Due: " +
                                      moment(
                                        vehicle.nextInspectionDue[0].nextDueDate
                                      ).format("MM-DD-YYYY")}
                                </div>
                                <div style={{ fontWeight: "bold" }}>
                                  {vehicle.nextInspectionDue !== null &&
                                  vehicle.nextInspectionDue !== undefined &&
                                  vehicle.nextInspectionDue.length === 0
                                    ? "BIT Next Due: " +
                                      moment(
                                        vehicle.nextInspectionDue[0].nextDueDate
                                      ).format("MM-DD-YYYY")
                                    : " "}
                                </div>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                {dotChecked && (
                                  <div style={{ fontWeight: "bold" }}>
                                    {vehicle.nextInspectionDue === null ||
                                    vehicle.nextInspectionDue === undefined ||
                                    vehicle.nextInspectionDue.length === 0
                                      ? ""
                                      : "DOT Next Due: " +
                                        moment(
                                          vehicle.nextInspectionDue[0]
                                            .nextDueDate
                                        ).format("MM-DD-YYYY")}
                                  </div>
                                )}
                                {bitChecked && (
                                  <div style={{ fontWeight: "bold" }}>
                                    {vehicle.nextInspectionDue !== null &&
                                    vehicle.nextInspectionDue !== undefined &&
                                    vehicle.nextInspectionDue.length > 1
                                      ? "BIT Next Due: " +
                                        moment(
                                          vehicle.nextInspectionDue[1]
                                            .nextDueDate
                                        ).format("MM-DD-YYYY")
                                      : vehicle.nextInspectionDue !== null &&
                                        vehicle.nextInspectionDue !==
                                          undefined &&
                                        vehicle.nextInspectionDue.length === 1
                                      ? "BIT Next Due: " +
                                        moment(
                                          vehicle.nextInspectionDue[0]
                                            .nextDueDate
                                        ).format("MM-DD-YYYY")
                                      : " "}
                                  </div>
                                )}
                              </React.Fragment>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <hr style={{ marginTop: -20 }} />
                      <div style={{}}>
                        <Row>
                          <Col xs="12" md="12">
                            <Row>
                              <Col xs="6">
                                <Row>
                                  <Col sm="4">Vehicle Id</Col>
                                  <Col>{vehicle.customerVehicleId}</Col>
                                </Row>
                              </Col>
                              <Col xs="6">
                                <Row>
                                  <Col sm="4">Vehicle Type</Col>
                                  <Col>
                                    {vehicle.vehicleType &&
                                      vehicle.vehicleType.vehicleType}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs="6">
                                <Row>
                                  <Col sm="4">Model</Col>
                                  <Col>{vehicle.model}</Col>
                                </Row>
                              </Col>
                              <Col xs="6">
                                <Row>
                                  <Col sm="4">VIN</Col>
                                  <Col>{vehicle.VIN}</Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs="6">
                                <Row>
                                  <Col sm="4">License</Col>
                                  <Col>{vehicle.license}</Col>
                                </Row>
                              </Col>
                              <Col xs="6">
                                <Row>
                                  <Col sm="4">Category</Col>
                                  <Col>
                                    {vehicle.vehicleType &&
                                      vehicle.vehicleType.vehicleCategory}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs="6">
                                <Row>
                                  <Col sm="4">Inspection Location</Col>
                                  <Col>{}</Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <Row className="justify-content-center px-3">
                          <Col md={4}>
                            <Btn
                              className=" btn-lg btn-block mt-2"
                              color="default"
                              onClick={() => this.cancelForm()}
                            >
                              Back
                            </Btn>
                          </Col>
                          <Col md={4}>
                            {this.state.regType !== "FEDERAL_BIT" ? (
                              <Btn
                                className=" btn-lg btn-block mt-2"
                                color="primary"
                                onClick={() => this.startInsp()}
                              >
                                Start Inspection
                              </Btn>
                            ) : (
                              <Btn
                                className=" btn-lg btn-block mt-2"
                                color="primary"
                                onClick={() => this.startSpecifiedInsp()}
                              >
                                Start Inspection
                              </Btn>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
            <this.RenderMileageBox />
            {/* <this.RenderInspDialog /> */}
          </section>
        </main>
      </div>
    );
  }
}
const cardStyle = {
  display: "block",
  width: "100%",
  height: "100%",
  padding: "5px",
  backgroundColor: "white",
  cursor: "pointer",
  margin: "15px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  transition: "0.3s",
  borderRadius: "5px",
  "&:hover": {
    boxShadow: "0 8px 16px 0 rgba(0,0,0,0.2)"
  }
};
const mapStateToProps = state => {
  return {
    user: state.config.user,
    loading: state.inspections.loading,
    data: state.inspections.data,
    client: state.config.client,
    profile: state.config.profile
  };
};

export default InspectionDetail = connect(mapStateToProps)(
  withStyles(styles)(InspectionDetail)
);



// WEBPACK FOOTER //
// ./src/inspection/inspectionDetails.jsx